document.addEventListener('DOMContentLoaded', function() {
  const dropdownTriggers = document.querySelectorAll('.header__inline-menu details');

  dropdownTriggers.forEach(trigger => {
    let timeoutId; // To handle potential rapid mouse movements

    trigger.addEventListener('mouseover', function() {
      clearTimeout(timeoutId); // Clear any pending timeouts

      if (!this.hasAttribute('open')) { // Only open if not already open
        this.setAttribute('open', '');
        const summary = this.querySelector('summary');
        summary.setAttribute('aria-expanded', 'true');
        const menuList = this.querySelector('ul');
        menuList.setAttribute('aria-hidden', 'false');
      }
    });


    trigger.addEventListener('mouseleave', function() { // Use mouseleave instead of mouseout
        timeoutId = setTimeout(() => { // Introduce a small delay
            this.removeAttribute('open');
            const summary = this.querySelector('summary');
            summary.setAttribute('aria-expanded', 'false');
            const menuList = this.querySelector('ul');
            menuList.setAttribute('aria-hidden', 'true');
        }, 200); // Delay of 200ms (adjust as needed)
    });

        // Add click event listener to keep the menu open if the user clicks on it
        const summary = trigger.querySelector('summary');
        summary.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default click behavior
            if (trigger.hasAttribute('open')) {
                trigger.removeAttribute('open');
                summary.setAttribute('aria-expanded', 'false');
                const menuList = trigger.querySelector('ul');
                menuList.setAttribute('aria-hidden', 'true');
            } else {
                trigger.setAttribute('open', '');
                summary.setAttribute('aria-expanded', 'true');
                const menuList = trigger.querySelector('ul');
                menuList.setAttribute('aria-hidden', 'false');
            }
        });
  });
});